export const useCheckTypeNotification = () => {
  const checkTypeNotification = (data: any) => {

    // 0 Appointment, cita
    // 1 Transaction, 
    // 2 Record, prestacion
    // 3 ConfirmationPart, parte de confirmacion
    // 4 DischargeLeavePart, parte alta baja
    // 5 ManagementDocument, documentos generales
    // 6 SumaryCATA, no exite
    // 7 WithoutLeavePart, parte sin baja
    // 8 WorkerEnvironment, no exite
    // 9 GeneralExpense, no existe
    // 10 IMSSummary, resumen IMS
    // 11 OrthoprostheticReplacement, reposicion ortoprotesica
    // 12 Recovery, recobro
    // 13 RegulatoryBaseCATA, base reguladora cata
    // 14 SpecialBenefitsCommission, comision prestaciones especiales
    // 15 TSDPayment, compensacion SLD
    // 16 HealthcareDocument, documentos asistenciales
    // 17 Hospitalization, 
    // 18 OperationRoom, quirofano
    // 19 Rehabilitation, 
    // 20 Visit, ambulatorio
    // 21 General,
    // 22 Survey

    let historyObject = {
      pathname: ''
    };
    if (data.scope && data.scope === 1) { //prestaciones_pacientes
      data.record_type = data.tipoPrestacion;
      data.record_id = data.prestacionId;
      data.type = data.tipoComponente;
    }
    switch (data.scope) {
      case 0: // Citas
        historyObject = {
          pathname: `/mis-citas/${data.componenteId}`
        }
        return historyObject;
      case 1: // Prestaciones Pacientes
        return checkTypeNotificationPresatcionesPacientes(data);

      case 2: // comunicaciones
        historyObject = {
          pathname: `/comunicaciones`
        }
        return historyObject;
      case 3: // peticiones externas
        historyObject = {
          pathname: `/mis-citas/externa/${data.componenteId}`
        }

        return historyObject;
      case 6: // gestiones
        historyObject = {
          pathname: `/mis-gestiones`
        }
        return historyObject;
      default:
        return;
    }

  }
  const checkTypeNotificationPresatcionesPacientes = (data: any) => {

    let historyObject = {
      pathname: `/historial/${data.record_type}_${data.record_id}`
    };
    if (data.seccionDestino === 1) {
      const highlightId = data.componenteId || 'documents';
      historyObject.pathname += `?scrollTo=generalDocuments&highlightId=${highlightId}`;
      return historyObject;
    }

    if (data.seccionDestino === 3) {
      const highlightId = data.componenteId || 'documents';
      historyObject = {
        pathname: `/historial/${data.record_type}_${data.record_id}_${data.tipoContingencia}/informacion-asistencial/${data.type}/${data.componenteId}?scrollTo=documents&highlightId=${highlightId}`
      };
      return historyObject;
    }

    switch (data.type) {
      case 0: // Parte confirmacion
      case 1: // parte alta baja
      case 2: // parte sin baja
        historyObject = {
          pathname: `/historial/${data.record_type}_${data.record_id}/administracion/${data.type}__${data.componenteId}`
        }
        return historyObject;

      case 100: // BaseReguladoraCATA
      case 101: // BaseReguladora
      case 102: // ComisionPrestacionesEspeciales
      case 103: // CompensacionSLD
      case 104: // GastosAsistencial
      case 105: // GastosFarmacia
      case 106: // GastosJuridico
      case 107: // GastosTransporte
      case 108: // Recobros
      case 109: // Regularizacion
      case 110: // ReposicionOrtoprotesica
      case 111: // ResumenIMS
      case 112: // PagoDirecto
        historyObject = {
          pathname: `/historial/${data.record_type}_${data.record_id}/económico/${data.type}__${data.componenteId}`
        }
        return historyObject;

      case 200: // EpisodioAmbulatorio
      case 201: // CentroExterno
      case 202: // Hospitalizacion
      case 203: // Imagen
      case 204: // Quirofano
      case 205: // Rehabilitacion
      case 206: // Urgencia
        historyObject = {
          pathname: `/historial/${data.record_type}_${data.record_id}_${data.tipoContingencia}/informacion-asistencial/${data.type}/${data.componenteId}`
        }
        return historyObject;
      case 207: // documentacion - redirige con tipo-componente como query param
        historyObject = {
          pathname: `/historial/${data.record_type}_${data.record_id}_${data.tipoContingencia}/informacion-asistencial?tipo-componente=${data.type}`
        }
        return historyObject;
      case 300: // formulario-real-decreto

        historyObject = {
          pathname: `/formulario-real-decreto/${data.record_type}_${data.record_id}/${data.componenteId}`
        }
        return historyObject;
      case 302: //formulario solicitud-gastos-contingencia-profesional

        historyObject = {
          pathname: `/solicitud-gastos-contingencia-profesional/${data.record_type}_${data.record_id}/${data.componenteId}`
        }
        return historyObject;
      case 303: // formulario-certificado-empresa

        historyObject = {
          pathname: `/formulario-certificado-empresa/${data.record_type}_${data.record_id}/${data.componenteId}`
        }
        return historyObject;
      case 304: // formulario-declaracion-situacion-actividad

        historyObject = {
          pathname: `/declaracion-situacion-actividad/${data.record_type}_${data.record_id}/${data.componenteId}`
        }
        return historyObject;
      case 305: // formulario-pago-directo

        historyObject = {
          pathname: `/solicitud-pago-directo-incapacidad-temporal/${data.record_type}_${data.record_id}/${data.componenteId}`
        }
        return historyObject;
      case 306: // empleados del hogar

        historyObject = {
          pathname: `/prestacion-empleados-hogar/${data.record_type}_${data.record_id}/${data.componenteId}`
        }
        return historyObject;
      case 307: // reconocmiento riesgo embarazo
        historyObject = {
          pathname: `/formulario-reconocimiento-rel/${data.record_type}_${data.record_id}/${data.componenteId}`
        }
        return historyObject;
      case 309: // prestacion-economica-rel

        historyObject = {
          pathname: `/formulario-prestacion-economica-rel/${data.record_type}_${data.record_id}/${data.componenteId}`
        }
        return historyObject;
      case 313: // formulario-pago-unico-cata

        historyObject = {
          pathname: `/pago-unico-cata/${data.record_type}_${data.record_id}/${data.componenteId}`
        }
        return historyObject;
      case 314: // formulario-reanudacion-cata

        historyObject = {
          pathname: `/formulario-reanudacion-cata/${data.record_type}_${data.record_id}/${data.componenteId}`
        }
        return historyObject;
      case 321: // prestacion-modalidad-ciclica

        historyObject = {
          pathname: `/prestacion-modalidad-ciclica/${data.record_type}_${data.record_id}/${data.componenteId}`
        }
        return historyObject;
      case 323: // prestacion-modalidad-ciclica

        historyObject = {
          pathname: `/prestacion-cume/${data.record_type}_${data.record_id}/${data.componenteId}`
        }
        return historyObject;
      case 322: // prestacion-modalidad-sectorial

        historyObject = {
          pathname: `/prestacion-modalidad-sectorial/${data.record_type}_${data.record_id}/${data.componenteId}`
        }
        return historyObject;
      case 326: // formulario-trabajador-cuenta-propia

        historyObject = {
          pathname: `/trabajador-cuenta-propia/${data.record_type}_${data.record_id}/${data.componenteId}`
        }
        return historyObject;
      case 328: // formulario-prestaciones-especiales

        historyObject = {
          pathname: `/prestaciones-especiales/${data.record_type}_${data.record_id}/${data.componenteId}`
        }
        return historyObject;
      case 329: // formulario-modelo145

        historyObject = {
          pathname: `/solicitud-modelo145/${data.record_type}_${data.record_id}/${data.componenteId}`
        }
        return historyObject;
      case 333: // formulario-emeplado-hogar

        historyObject = {
          pathname: `/prestacion-empleados-hogar/${data.record_type}_${data.record_id}/${data.componenteId}`
        }
        return historyObject;
      case 334: // formulario-cata-fuego

        historyObject = {
          pathname: `/formulario-cata-fuego/${data.record_type}_${data.record_id}/${data.componenteId}`
        }
        return historyObject;
      case 335: // formulario-gastos-farmacia

        historyObject = {
          pathname: `/solicitud-gastos-farmacia/${data.record_type}_${data.record_id}/${data.componenteId}`
        }
        return historyObject;
      case 336: // formulario-gastos-ortopedia

        historyObject = {
          pathname: `/solicitud-gastos-ortopedia/${data.record_type}_${data.record_id}/${data.componenteId}`
        }
        return historyObject;
      case 337: // formulario-gastos-transporte

        historyObject = {
          pathname: `/solicitud-gastos-transporte/${data.record_type}_${data.record_id}/${data.componenteId}`
        }
        return historyObject;
      default: return historyObject;
    }

  }

  return { checkTypeNotification }

}